import { createFileRoute, redirect } from "@tanstack/react-router";

// Consolidated into the ONE Spanish "What is SAINT?" guide at
// /es/learn/what-is-saint-tms (served by the dynamic /es/learn/$slug route).
// Edge 301 is mirrored in public/_redirects.
const DESTINATION: string = "/es/learn/what-is-saint-tms";
export const Route = createFileRoute("/es/what-is-saint-tms")({
  beforeLoad: () => {
    throw redirect({ to: DESTINATION, statusCode: 301 });
  },
});
